(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../braindate/schema", "../../user/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../braindate/schema"), require("../../user/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema, _schema2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.expressionOfGratitudesShema = _exports.expressionOfGratitudeSchema = void 0;

  /**
   * Schema for a single expressionOfGratitude
   * @type {schema.Entity}
   */
  var expressionOfGratitudeSchema = new _normalizr.schema.Entity(_setting.expressionOfGratitudeEntityKey, {
    braindate: _schema.braindateSchema,
    sender: _schema2.userSchema,
    recipeint: _schema2.userSchema
  });
  _exports.expressionOfGratitudeSchema = expressionOfGratitudeSchema;
  var expressionOfGratitudesShema = [expressionOfGratitudeSchema];
  _exports.expressionOfGratitudesShema = expressionOfGratitudesShema;
});